(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["orvon-product-feedback"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('orvon-product-feedback')) {
    customElements.define(
      'orvon-product-feedback',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.feedbackReady === 'true') return;
          this.dataset.feedbackReady = 'true';

          const dialog = this.querySelector('[data-feedback-dialog]');
          const openButton = this.querySelector('[data-feedback-open]');
          const closeButtons = this.querySelectorAll('[data-feedback-close]');
          const shouldOpen = this.querySelector('[data-feedback-success], [data-feedback-errors]');
          const form = this.querySelector('form');
          const requiredEmail = this.querySelector('[data-feedback-required-email]');
          const optionalEmail = this.querySelector('[data-feedback-optional-email]');

          if (!dialog || !openButton) return;

          const openDialog = () => {
            if (!dialog.open) dialog.showModal();
            const focusTarget = dialog.querySelector('[data-feedback-success], [data-feedback-textarea]');
            requestAnimationFrame(() => focusTarget?.focus());
          };

          const closeDialog = () => {
            dialog.close();
            openButton.focus();
          };

          openButton.addEventListener('click', openDialog);
          closeButtons.forEach((button) => button.addEventListener('click', closeDialog));
          dialog.addEventListener('click', (event) => {
            if (event.target === dialog) closeDialog();
          });
          form?.addEventListener('submit', () => {
            const providedEmail = optionalEmail?.value.trim();
            requiredEmail.value = providedEmail || requiredEmail.defaultValue;
          });

          if (shouldOpen) openDialog();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
